
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="https://static.readdy.ai/image/50f4002bde5ecf02750e3107d0496ef3/ea8d57dd3e7415a4fbb16dc09a9dc337.jpeg" 
                alt="LedgRkeepR" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Professional financial services helping businesses optimize their operations and achieve sustainable growth through expert analysis and strategic guidance.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => handleNavigation('/bookkeeping')}
                  className="text-gray-300 hover:text-white cursor-pointer"
                >
                  Bookkeeping
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation('/medical-billing')}
                  className="text-gray-300 hover:text-white cursor-pointer"
                >
                  Medical Billing
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation('/cost-accounting')}
                  className="text-gray-300 hover:text-white cursor-pointer"
                >
                  Cost Accounting
                </button>
              </li>
              <li>
                <a href="/tax-planning" onClick={(e) => { e.preventDefault(); handleNavigation('/tax-planning'); }} className="text-gray-300 hover:text-white cursor-pointer">Tax Planning</a>
              </li>
              <li>
                <a href="/financial-consulting" onClick={(e) => { e.preventDefault(); handleNavigation('/financial-consulting'); }} className="text-gray-300 hover:text-white cursor-pointer">
                  Financial Consulting
                </a>
              </li>
              <li>
                <a href="/audit-support" onClick={(e) => { e.preventDefault(); handleNavigation('/audit-support'); }} className="text-gray-300 hover:text-white cursor-pointer">Audit Support</a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => handleNavigation('/about')}
                  className="text-gray-300 hover:text-white cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/contact')}
                  className="text-gray-300 hover:text-white cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-300 text-sm">
            © 2025 LedgRkeepR. All rights reserved.
          </p>
          <div className="text-gray-300 text-sm mt-2 md:mt-0">
            <button 
              onClick={() => handleNavigation('/terms-conditions')}
              className="text-gray-300 hover:text-white cursor-pointer mr-4"
            >
              Terms and Conditions
            </button>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
